import {Component, OnInit} from '@angular/core';
import {FilterService} from '../service/filter.service';
import {forEach} from 'typescript-collections/dist/lib/arrays';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import {CampaignService} from '../../campaign/service/campaign.service';

@Component({
  selector: 'app-filter-view',
  templateUrl: './filter-view.component.html',
  styleUrls: ['./filter-view.component.css']
})
export class FilterViewComponent implements OnInit {
  public filterList: any = [];
  public userFilterList: any = [];
  public campaignList: any = [];
  searchTerm: FormControl = new FormControl();
  public filterMap = {};
  public userFilterMap = {};
  public loading = true;
  public campaignFilterFlag = false;
  public campaignId: any;
  constructor(private filterService: FilterService, private campaignService: CampaignService, private router: Router,  private toastr: ToastrService) { }

  ngOnInit() {
    this.getAllSystemFilters();
      this.searchTerm.valueChanges.subscribe(
          term => {
              if (term !== '') {
                  this.campaignService.search(term, 0, 999).subscribe(
                      data => {
                          const response = data.json();
                          this.campaignList = response.campaigns;
                      });
              }
          });
  }

    inputChecked(filter) {
        let checked = false;
        if (filter.enabled) {
            checked = true;
        }
        return checked;
    }

    inputCheckedOverride(evet) {
        let checked = false;
        if (evet.checked) {
            checked = true;
        }
        return checked;
    }

    editFilter(filterId, id) {
      console.log(filterId);
      if (this.campaignId === undefined) {
          this.router.navigate( [ '/elasticcare/add/filter' , {filterIdParam: filterId} ]);
      } else {
          this.router.navigate( [ '/elasticcare/add/filter' , {filterIdParam: filterId, campaignIdParam: this.campaignId} ]);
      }
    }

  onChange(filter, isChecked: boolean) {
      console.log(filter);

      if (isChecked) {
          filter.enabled = true;
      } else {
          filter.enabled = false;
      }
      console.log(isChecked);
      console.log(filter);
      this.filterService.updateFilters(filter)
          .subscribe(data => {
              this.loading = false;
          }, (error: any) => {
              const response: any = error._body;
              let filterArray = this.filterMap[filter.category];
              for (let i = 0 ; i < filterArray.length ; i++) {
                      if(filter.name === filterArray[i].name && filter.campaignId === filterArray[i].campaignId){
                          filterArray[i].enabled = false;
                      }
              }

              let usrFilterArray = this.userFilterMap[filter.category];
              for (let i = 0 ; i < usrFilterArray.length ; i++) {
                      if(filter.name === usrFilterArray[i].name && filter.campaignId === usrFilterArray[i].campaignId){
                          usrFilterArray[i].enabled = false;
                      }
              }
              this.toastr.error('', response);
              this.loading = false;
          });

  }

  onChangeOverride(isChecked: boolean) {
      let checked = false;
      if (isChecked) {
          checked = true;
          this.filterService.getAllSystemFilters()
              .subscribe(data => {
                  const response: any = data.json();
                  this.filterList = response;
                  for (let i = 0 ; i < this.filterList.length ; i++) {
                      this.filterList[i].id = null;
                      this.filterList[i].campaignId = this.campaignId;
                  }
                  console.log(this.filterList);
                  this.filterService.saveFilters(this.filterList)
                      .subscribe(dataSave => {
                          if (dataSave.status === 200) {
                              this.getCampaign(this.campaignId);
                          }
                          this.loading = false;
                      }, (error) => {
                          this.loading = false;
                      });
                  this.loading = false;
              }, (error) => {
                  this.loading = false;
                  this.toastr.error('', 'Please try again');
              });

      }
      return checked;
  }

  public getAllSystemFilters() {
    this.filterService.getAllSystemFilters()
        .subscribe(data => {
          const response: any = data.json();
          this.filterList = response;

          for (let i = 0 ; i < this.filterList.length; i++) {
            let filterArray = this.filterMap[this.filterList[i].category];
            if (!filterArray) {
              filterArray = [];
              this.filterMap[this.filterList[i].category] = filterArray;
            }
            filterArray.push(this.filterList[i]);
          }

          console.log(this.filterMap);
          this.loading = false;
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  getCampaign(event) {
      console.log(event);
      this.filterService.getFiltersByCampaignId(event)
          .subscribe(data => {
              const response: any = data.json();
              this.userFilterList = response;
              this.campaignId = event;
              this.campaignFilterFlag = this.userFilterList.length > 0 ? true : false;
              for (let i = 0 ; i < this.userFilterList.length; i++) {
                  let filterArray = this.userFilterMap[this.userFilterList[i].category];
                  if (!filterArray) {
                      filterArray = [];
                      this.userFilterMap[this.userFilterList[i].category] = filterArray;
                  }
                  filterArray.push(this.userFilterList[i]);
              }

              console.log(this.userFilterMap);
              this.loading = false;
          }, (error) => {
              this.loading = false;
              // this.toastr.error('', 'Please try again');
          });
  }

}
